import { PostAPI } from 'Components/Helper/Helpers';

export const GenerteOTP = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/GenerateOTP');
};

export const AddWithOTP = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/VerifyOTP');
};
export const SelectSetting = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/Select');
};

export const Update = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/Update');
};

export const DeleteSetting = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/Delete');
};

export const GenerateOTPForSettingUpdate = async (request) => {
    return PostAPI(request, 'AutoTransferUserwiseMapping/GenerateOTPForUpdate');
};
